export enum SkuPriceCollectionName {
	CLEARANCE = 'clearance',
	COMBINATION = 'combination',
	DISCOUNT = 'discount',
	MARKDOWN = 'markdown',
	REGULAR = 'regular'
}